import { call, put, takeLatest } from 'redux-saga/effects';
import { PayloadAction } from '@reduxjs/toolkit';
import { modulesApi } from '../../api/modules-api';
import {
  fetchModulesSuccess,
  fetchModuleSuccess,
  createModuleSuccess,
  updateModuleSuccess,
  fetchCategoriesSuccess,
  createCategorySuccess,
  updateCategorySuccess,
  deleteCategorySuccess,
  modulesFailure,
  CreateCategoryRequest,
  UpdateCategoryRequest,
  DeleteCategoryRequest,
} from '../modules-slice';

// Saga para obtener módulos
function* fetchModulesSaga(action: PayloadAction<any>): Generator<any, void, any> {
  try {
    const response: any = yield call(modulesApi.modules.getModules, action.payload);
    yield put(fetchModulesSuccess(response));
  } catch (error: any) {
    yield put(modulesFailure(error.message || 'Error al obtener los módulos'));
  }
}

// Saga para obtener un módulo específico
function* fetchModuleSaga(action: PayloadAction<any>): Generator<any, void, any> {
  try {
    const { id } = action.payload;
    const response: any = yield call(modulesApi.modules.getModule, id);
    const module = response.data || response;
    yield put(fetchModuleSuccess(module));
  } catch (error: any) {
    yield put(modulesFailure(error.message || 'Error al obtener el módulo'));
  }
}

// Saga para crear módulo
function* createModuleSaga(action: PayloadAction<any>): Generator<any, void, any> {
  try {
    const { data } = action.payload;
    const response: any = yield call(modulesApi.modules.createModule, data);
    const module = response.data || response;
    yield put(createModuleSuccess(module));
  } catch (error: any) {
    yield put(modulesFailure(error.message || 'Error al crear el módulo'));
  }
}

// Saga para actualizar módulo
function* updateModuleSaga(action: PayloadAction<any>): Generator<any, void, any> {
  try {
    const { id, data } = action.payload;
    const response: any = yield call(modulesApi.modules.updateModule, id, data);
    const module = response.data || response;
    yield put(updateModuleSuccess(module));
  } catch (error: any) {
    yield put(modulesFailure(error.message || 'Error al actualizar el módulo'));
  }
}

function* toggleModuleStatusSaga(action: PayloadAction<any>): Generator<any, void, any> {
  try {
    const { id } = action.payload;
    const response: any = yield call(modulesApi.modules.toggleModuleStatus, id);
    const module = response.data || response;
    yield put(updateModuleSuccess(module));
  } catch (error: any) {
    yield put(modulesFailure(error.message || 'Error al cambiar el estado del módulo'));
  }
}

// Saga para obtener categorías
function* fetchCategoriesSaga(): Generator<any, void, any> {
  try {
    const response: any = yield call(modulesApi.categories.getCategories);
    const categories = response.data || response;
    yield put(fetchCategoriesSuccess(categories));
  } catch (error: any) {
    yield put(modulesFailure(error.message || 'Error al obtener las categorías'));
  }
}

// Saga para crear categoría
function* createCategorySaga(
  action: PayloadAction<CreateCategoryRequest>
): Generator<any, void, any> {
  try {
    const { data } = action.payload;
    const response: any = yield call(modulesApi.categories.createCategory, data);
    const category = response.data || response;
    yield put(createCategorySuccess(category));
  } catch (error: any) {
    yield put(modulesFailure(error.message || 'Error al crear la categoría'));
  }
}

// Saga para actualizar categoría
function* updateCategorySaga(
  action: PayloadAction<UpdateCategoryRequest>
): Generator<any, void, any> {
  try {
    const { id, data } = action.payload;
    const response: any = yield call(modulesApi.categories.updateCategory, id, data);
    const category = response.data || response;
    yield put(updateCategorySuccess(category));
  } catch (error: any) {
    yield put(modulesFailure(error.message || 'Error al actualizar la categoría'));
  }
}

// Saga para eliminar categoría
function* deleteCategorySaga(
  action: PayloadAction<DeleteCategoryRequest>
): Generator<any, void, any> {
  try {
    const { id } = action.payload;
    yield call(modulesApi.categories.deleteCategory, id);
    yield put(deleteCategorySuccess(id));
  } catch (error: any) {
    yield put(modulesFailure(error.message || 'Error al eliminar la categoría'));
  }
}

// Watcher sagas
export function* watchFetchModules() {
  yield takeLatest('modules/fetchModules', fetchModulesSaga);
}

export function* watchFetchCategories() {
  yield takeLatest('modules/fetchCategories', fetchCategoriesSaga);
}

export function* watchFetchModule() {
  yield takeLatest('modules/fetchModule', fetchModuleSaga);
}

export function* watchCreateModule() {
  yield takeLatest('modules/createModule', createModuleSaga);
}

export function* watchUpdateModule() {
  yield takeLatest('modules/updateModule', updateModuleSaga);
}

export function* watchCreateCategory() {
  yield takeLatest('modules/createCategory', createCategorySaga);
}

export function* watchUpdateCategory() {
  yield takeLatest('modules/updateCategory', updateCategorySaga);
}

export function* watchDeleteCategory() {
  yield takeLatest('modules/deleteCategory', deleteCategorySaga);
}

// Root saga para modules
export function* modulesSaga() {
  yield takeLatest('modules/fetchModules', fetchModulesSaga);
  yield takeLatest('modules/fetchModule', fetchModuleSaga);
  yield takeLatest('modules/createModule', createModuleSaga);
  yield takeLatest('modules/updateModule', updateModuleSaga);
  yield takeLatest('modules/toggleModuleStatus', toggleModuleStatusSaga);
  yield takeLatest('modules/fetchCategories', fetchCategoriesSaga);
  yield takeLatest('modules/createCategory', createCategorySaga);
  yield takeLatest('modules/updateCategory', updateCategorySaga);
  yield takeLatest('modules/deleteCategory', deleteCategorySaga);
}
